import DropZoneInput from './DropZoneInput';

export default DropZoneInput;
